export default __webpack_public_path__ + "static/media/profile_avatar.800081b4.jpg";